import { render, staticRenderFns } from "./WarehouseInfo.vue?vue&type=template&id=36aa49d4"
import script from "./WarehouseInfo.vue?vue&type=script&lang=js"
export * from "./WarehouseInfo.vue?vue&type=script&lang=js"
import style0 from "./WarehouseInfo.vue?vue&type=style&index=0&id=36aa49d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports